var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.23209 10.4602C6.39405 10.4603 7.52278 10.0726 8.43948 9.35857L11.8979 12.817C12.1563 13.0665 12.5679 13.0593 12.8174 12.801C13.0608 12.549 13.0608 12.1494 12.8174 11.8974L9.35902 8.43903C11.1308 6.15832 10.7182 2.87316 8.43748 1.10142C6.15677 -0.670318 2.87164 -0.25774 1.0999 2.02297C-0.671844 4.30368 -0.259267 7.58883 2.02144 9.36057C2.93964 10.0739 4.06937 10.4608 5.23209 10.4602ZM2.45329 2.45281C3.988 0.918078 6.47625 0.91805 8.01099 2.45276C9.54572 3.98746 9.54575 6.47571 8.01104 8.01045C6.47633 9.54519 3.98808 9.54521 2.45334 8.01051C2.45332 8.01048 2.45332 8.01048 2.45329 8.01045C0.91858 6.48693 0.909538 4.00774 2.43306 2.47304C2.4398 2.46628 2.44653 2.45955 2.45329 2.45281Z","fill":"black"}));
}

Search.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Search;

Search.default = Search;
